export type State = {
	selectedCols: Set<number>;
	selectedRows: Set<number>;
};

export const initState: State = {
	selectedCols: new Set(),
	selectedRows: new Set(),
};
